const useKindTagChip = (tag) => {
  if (!tag) return null;

  const defaultKind = { label: tag, kind: 'default' };

  const kinds = {
    active: {
      label: 'Ativo',
      kind: 'success',
    },
    inactive: {
      label: 'Inativo',
      kind: 'attention',
    },
    delinquent: {
      label: 'Inadimplente',
      kind: 'warning',
    },
    archived: {
      label: 'Arquivado',
      kind: 'default',
    },
  };

  return kinds[tag] || defaultKind;
};

export default useKindTagChip;
